var chunkToChildrenMap = {
	"326": [
		70,
		301,
		274,
		13,
		488,
		852,
		879,
		836,
		272,
		532,
		7
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };